var AccordionHeadingLevels;
(function (AccordionHeadingLevels) {
  AccordionHeadingLevels["H1"] = 'h1';
  AccordionHeadingLevels["H2"] = 'h2';
  AccordionHeadingLevels["H3"] = 'h3';
  AccordionHeadingLevels["H4"] = 'h4';
  AccordionHeadingLevels["H5"] = 'h5';
  AccordionHeadingLevels["H6"] = 'h6';
})(AccordionHeadingLevels || (AccordionHeadingLevels = {}));
var AccordionHeaderContentPositions;
(function (AccordionHeaderContentPositions) {
  AccordionHeaderContentPositions["After"] = 'after';
  AccordionHeaderContentPositions["Before"] = 'before';
})(AccordionHeaderContentPositions || (AccordionHeaderContentPositions = {}));
var AccordionButtonIconPositions;
(function (AccordionButtonIconPositions) {
  AccordionButtonIconPositions["After"] = 'after';
  AccordionButtonIconPositions["Before"] = 'before';
})(AccordionButtonIconPositions || (AccordionButtonIconPositions = {}));
var AccordionAnimations;
(function (AccordionAnimations) {
  AccordionAnimations["FadeIn"] = 'fadeIn';
  AccordionAnimations["FadeInFromTop"] = 'fadeInFromTop';
})(AccordionAnimations || (AccordionAnimations = {}));
export { AccordionAnimations, AccordionButtonIconPositions, AccordionHeaderContentPositions, AccordionHeadingLevels };